'use client';

import FaIcon, { faClock } from '../../../../components/icon/FaIcon/FaIcon';
import { ImageView, WChanceStaging } from '../../../../components/ui';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { newDate } from '../../../../utils/date';
import type { WChanceDrawResultGoodsItem } from '../../types';
import styles from './WChancePrizeDetail.module.scss';
export type WChancePrizeDetailProps = {
  wChanceResults: WChanceDrawResultGoodsItem[];
  name: string;
};

function WChancePrizeDetail({ wChanceResults, name }: WChancePrizeDetailProps) {
  const wChanceResult = wChanceResults[0];

  // 日時フォーマット関数（date.tsを修正せずに済むよう、ここで定義）
  const formatDateTime = (dateStr: string) => {
    const date = newDate(dateStr);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
  };

  // Wチャンス日付を表示するかどうかの判定
  const showWChanceDateInfo = () => {
    if (wChanceResult.startAt && wChanceResult.endAt ) return true;
    return false;
  }

  return (
    <>
      <div className={styles.componentStyle}>
        <div className={styles.header}>Wチャンス賞　対象景品</div>
        <div className={utilsStyles.mtSmall}>
          <div className={styles.imageWrapper}>
            <div className={styles.itemImage}>
              <ImageView src={wChanceResult.imageUrl} />
              {/* 演出 */}
              <div className={styles.rankWrapper}>
                <WChanceStaging size={'xLarge'} />
              </div>
            </div>
          </div>
          <div className={styles.itemInfo}>
            <div className={`${styles.itemName} ${utilsStyles.textBold}`}>{name}</div>
            {showWChanceDateInfo() && (
              <div className={styles.dateInfo}>
                <FaIcon icon={faClock} size={'lg'} />
                &nbsp;
                {/* showWChanceDateInfo()でstartAt・endAtの存在は確認済みだが、メソッド化すると型の絞り込み(type narrowing)が効かずstring | undefinedのままになるため、!で非nullを明示 */}
                {formatDateTime(wChanceResult.startAt!)} 〜 {formatDateTime(wChanceResult.endAt!)}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default WChancePrizeDetail;
